import type { FaireProductEntity } from "../../entity_types/product";

export const p_p9zg8y8uf9: FaireProductEntity = {
  token: "p_p9zg8y8uf9",
  type: "product",
  name: "Matches • Art • Van Gogh Sunflowers •Home Decor for Candles",
  brandToken: "b_6zicjtg87q",
  brandName: "Most Amazing",
  imageUrl:
    "https://cdn.faire.com/fastly/769363cee5c949fc7ff1bdd7734bfa1dbf10e9371e4c9550d16121c434885675.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/50f43223c6a04529efe1e4debcca01569e5619925d208cb674684f7160d07792.jpeg",
    "https://cdn.faire.com/fastly/0d36dfc98ab3b661f9f6ab8e1e3d8e1f1a94ea609bd2c422eaa4a2fd2bedddb8.jpeg",
  ],
  priceDollars: 1.66,
  description:
    "• Matches to elevate your home decor. Light your candles and incense with style.\n• These unique matchboxes feature the classic art of Vincent Van Gogh Sunflowers on both sides\n• Each box contains 20-23 matches and measures about  2.25”x1.5”x.5”\n\n• NOW AVAILABLE! - CUSTOMIZE a Matchbox with YOUR SHOP LOGO! https://www.faire.com/product/p_zdp5asfpuq",
  tags: [],
  msrpDollars: 3.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:30.570Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
